module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="m-modal-section">\n\n\n    <div class="m-modal-section__title">Schedule</div>\n    <div class="m-modal-column">\n        <div class="form-group">\n            <label for="name">Date</label>\n            <input type="input" class="form-control js-date-picker-start" name="startDate" placeholder="" value="">\n        </div>\n    </div>\n\n\n</div>\n\n\n<div class="m-modal-section">\n    <div class="m-modal-section__title">Select a preset</div>\n    <div class="m-modal-column">\n        <div class="form-group">\n            <select class="form-control js-preset-select">\n                <option value="">Choose...</option>\n                ';
 _.each(getPresetList(), function(value){ 
__p+='\n                    <option value="'+
((__t=( value._id ))==null?'':__t)+
'">\n                        '+
((__t=( value.name ))==null?'':__t)+
'\n                    </option>\n                    ';
 }); 
__p+='\n            </select>\n        </div>\n    </div>\n</div>\n\n\n<!-- <div class="m-modal-section" >\n                    <div class="m-modal-section__title">Daily routine composer</div>\n                </div>\n\n                <div class="routine__region"></div> -->\n\n\n';
 _.each([0,1,2,3,4,5,6,7,8,9], function(value) { 
__p+='\n\n    <div class="m-modal-section no-bottom-padding">\n        <div class="m-modal-section__title">Composer '+
((__t=( value + 1 ))==null?'':__t)+
'\n        </div>\n    </div>\n    <div class="routine__region-dali_'+
((__t=( value + 1 ))==null?'':__t)+
'"></div>\n\n    ';
 }); 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/schedules/edit_new/templates/control-dali-x.html
// module id = 461
// module chunks = 0